import { render, staticRenderFns } from "./form-textarea.vue?vue&type=template&id=03464ad8&scoped=true"
import script from "./form-textarea.vue?vue&type=script&lang=js"
export * from "./form-textarea.vue?vue&type=script&lang=js"
import style0 from "./form-textarea.vue?vue&type=style&index=0&id=03464ad8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03464ad8",
  null
  
)

export default component.exports